<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="供应商">
                <a-select
                  v-model="queryParam.corpSupplierId"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in supplierList"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="客户">
                <a-select
                  v-model="queryParam.corpBusinessId"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in businessList"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="物料名称">
                <a-input v-model.trim="queryParam.materielName" placeholder />
              </a-form-item>
            </a-col>

            <span v-if=" !standTimeShow">
            <a-col :md="8" :sm="24">
              <a-form-item
                label="过磅日期"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-date-picker
                  v-model="queryParam.standDate"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  showTime
                  format="YYYY-MM-DD"
                  v-decorator="[
                       'dateRange',
                      {rules: [{ required: true, message: '请选择过磅日期'}]}
                    ]"
                />
              </a-form-item>
            </a-col>
            </span>

            <span v-if=" standTimeShow">
            <a-col :md="8" :sm="24">
              <a-form-item
                label="过磅时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.standTime"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  v-decorator="[
                      'dateRange',
                      {rules: [{ required: true, message: '请选择皮重时间'}]}
                    ]"
                />
              </a-form-item>
            </a-col>
            </span>

            <a-col :md="8" :sm="24">
              <a-form-item label="报表类型">
                <a-select
                  v-model="queryParam.reportId"
                  showSearch
                  :filterOption="filterOption"
                  @change="changeReportId"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value="过磅明细表" >过磅明细表</a-select-option>
                  <a-select-option value="称重报表">称重报表</a-select-option>
                  <a-select-option value="出厂日报表">出厂日报表</a-select-option>

                </a-select>
              </a-form-item>
            </a-col>

            <span v-if="  conditionShow">
            <a-col :md="8" :sm="24">
            <a-form-item label="条件1">
              <a-select
                v-model="queryParam.field1"
                showSearch
                :filterOption="filterOption"
                placeholder="请选择"
                default-value="0"
              >
                <a-select-option value="" >请选择</a-select-option>
                <a-select-option value="车号" >车号</a-select-option>
                <a-select-option value="物料名称">物料名称</a-select-option>
                <a-select-option value="发货单位">发货单位</a-select-option>
                <a-select-option value="收货单位">收货单位</a-select-option>

              </a-select>
            </a-form-item>
          </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="条件2">
                <a-select
                  v-model="queryParam.field2"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value="" >请选择</a-select-option>
                  <a-select-option value="车号" >车号</a-select-option>
                  <a-select-option value="物料名称">物料名称</a-select-option>
                  <a-select-option value="发货单位">发货单位</a-select-option>
                  <a-select-option value="收货单位">收货单位</a-select-option>

                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="条件3">
                <a-select
                  v-model="queryParam.field3"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value="" >请选择</a-select-option>
                  <a-select-option value="车号" >车号</a-select-option>
                  <a-select-option value="物料名称">物料名称</a-select-option>
                  <a-select-option value="发货单位">发货单位</a-select-option>
                  <a-select-option value="收货单位">收货单位</a-select-option>

                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="条件4">
                <a-select
                  v-model="queryParam.field4"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value="" >请选择</a-select-option>
                  <a-select-option value="车号" >车号</a-select-option>
                  <a-select-option value="物料名称">物料名称</a-select-option>
                  <a-select-option value="发货单位">发货单位</a-select-option>
                  <a-select-option value="收货单位">收货单位</a-select-option>

                </a-select>
              </a-form-item>
            </a-col>
            </span>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
             <!-- <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>-->
              <a-button type="primary" @click="queryTable()">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => {queryParam = {}; this.statusSelect = null}"
              >重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button  type="primary" @click="handleStandDetailExport()">过磅明细表</a-button>
      <a-button style="margin-left: 10px" type="primary" @click="standStatisticVoExport()">称重汇总</a-button>
      <a-button style="margin-left: 10px" type="primary" @click="reportVoExport()">出厂日报表</a-button>
    </div>
    <s-table
      v-if="report1"
      ref="table1"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns1"
      :data="loadData1"
      :scroll="{ x: 1600 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span
        slot="supplierName"
        slot-scope="text, record, index"
      >{{ record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName}}</span>

      <span slot="materielAction" slot-scope="text, record">
      </span>
    </s-table>
    <s-table
      v-if="report2"
      ref="table2"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns2"
      :data="loadData2"
      :scroll="{ x: 1600 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span
        slot="supplierName"
        slot-scope="text, record, index"
      >{{ record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName}}</span>

      <span slot="materielAction" slot-scope="text, record">
      </span>
    </s-table>

    <s-table
      v-if="report3"
      ref="table3"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns3"
      :data="loadData3"
      :scroll="{ x: 1600 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span
        slot="supplierName"
        slot-scope="text, record, index"
      >{{ record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName}}</span>

      <span slot="materielAction" slot-scope="text, record">
      </span>
    </s-table>
  </a-card>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import Bus from '@/layouts/bus'
  import { STable } from '@/components'
  import {
    reportPage,
    reportWeightPage,
    reportDayPage,
    weighingPage,
    weighingUploadInfo,
    weighingUpdateWeighingInfo,
    baseInfoList,
    weighingExport,
    weighingOrder,
    standDetailExport,
    standStatisticVoExport,
    reportVoExport
  } from '@/api/logistics'
  import { getCorpSupplierList, corpBusinessList } from '@/api/basic'
  import { userList } from '@/api/sys'
  import { formatDate } from '@/utils/date.js'
  import moment from 'moment'
  import { ReservationStatus } from '@/utils/config.js'
  import { getLogStatusTextByValue, getBizTextByValue } from '@/utils/util'
  import storage from '@/utils/storage'
  import { getLodop } from '@/tools/lodop/LodopFuncs'
  import queryMixin from '@/mixins/queryMixin'

  export default {
    name: 'ReservationList',
    mixins: [queryMixin],
    components: {
      STable
    },
    data() {
      return {
        pageSizeOptionsList:['10'],
        report1: true,
        report2:false,
        report3:false,
        standTimeShow:true,
        conditionShow:false,
        description:
          '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        // form: null,
        form: this.$form.createForm(this),
        bizCodeList: {},
        // bizList: [],
        bizList: this.$store.getters.bizList,
        statusList: [],

        selectedBizId: null,
        supplierList: [],
        businessList: [],
        supplierOrBusList: [],
        supplierOrBusId: null,

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: null,
        roleId: null,
        failReason: '',
        bizType: '',
        scaleType: '',

        materielData: {},
        materList: [],

        LODOP: null, // 声明打印全局变量
        downloadUrl: this.config.downloadUrl,
        // 表头
        columns1: [
          {
            title: '流水号',
            dataIndex: 'logisticsNo',
            width: '200px',
            fixed: 'left'
          },
          {
            title: '车号',
            dataIndex: 'vehicleNo',
            width: '250px'
          },
          {
            title: '物料名称',
            dataIndex: 'materielName',
            width: '150px'
          },
          {
            title: '发货单位',
            dataIndex: 'unitFrom',
            width: '290px',
          },
          {
            title: '收货单位',
            dataIndex: 'unitTo',
            width: '220px',
          },
          {
            title: '毛重',
            dataIndex: 'gross',
            width: '100px'
          },
          {
            title: '皮重',
            dataIndex: 'tare',
            width: '100px'
          },
          {
            title: '净重',
            dataIndex: 'net',
            width: '100px'
          },
          {
            title: '一次磅时间',
            dataIndex: 'beginTime',
            width: '180px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
        ],
        // 报表2
        columns2: [
          {
            title: '总车数',
            dataIndex: 'carNum',
            width: '220px',
          },
          {
            title: '总毛重',
            dataIndex: 'grossTotal',
            width: '220px',
          },
          {
            title: '总皮重',
            dataIndex: 'tareTotal',
            width: '220px',
          },
          {
            title: '总实重',
            dataIndex: 'netTotal',
            width: '220px',
          },
        ],
        // 报表2
        columns3: [
          {
            title: '车号',
            dataIndex: 'vehicleNo',
            width: '250px'
          },
          {
            title: '物料名称',
            dataIndex: 'materielName',
            width: '150px'
          },
          {
            title: '发货单位',
            dataIndex: 'unitFrom',
            width: '290px',
          },
          {
            title: '收货单位',
            dataIndex: 'unitTo',
            width: '220px',
          },
          {
            title: '包装方式',
            dataIndex: 'materielType',
            width: '220px',
          },
          {
            title: '当日重量',
            dataIndex: 'dayWeight',
            width: '220px',
          },
          {
            title: '月累计',
            dataIndex: 'monthWeight',
            width: '220px',
          },
          {
            title: '年累计',
            dataIndex: 'yearWeight',
            width: '220px',
          },
          {
            title: '当日车数',
            dataIndex: 'todayCarNum',
            width: '220px',
          },

        ],
        // 加载数据方法 必须为 Promise 对象
        loadData1: parameter => {
          if(this.queryParam.reportId !== undefined){
          }else{
            this.$message.success('请选择查询报表类型！')
          }
          if (this.queryParam.standTime !== undefined && this.queryParam.standTime.length > 1) {
            this.queryParam['beginStartTime'] = formatDate(new Date(this.queryParam.standTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['beginEndTime'] = formatDate(new Date(this.queryParam.standTime[1]), 'yyyy-MM-dd hh:mm:ss')
          } else {
            this.queryParam['beginStartTime'] = null
            this.queryParam['beginEndTime'] = null
          }
          return reportPage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })
        },

        loadData2: parameter => {
          if(this.queryParam.reportId !== undefined){
          }else{
            this.$message.success('请选择查询报表类型！')
          }
          if (this.queryParam.standTime !== undefined && this.queryParam.standTime.length > 1) {
            this.queryParam['beginStartTime'] = formatDate(new Date(this.queryParam.standTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['beginEndTime'] = formatDate(new Date(this.queryParam.standTime[1]), 'yyyy-MM-dd hh:mm:ss')
          } else {
            this.queryParam['beginStartTime'] = null
            this.queryParam['beginEndTime'] = null
          }
          return reportWeightPage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })
        },

        loadData3: parameter => {
          if(this.queryParam.reportId !== undefined){
          }else{
            this.$message.success('请选择查询报表类型！')
          }
          if (this.queryParam.standDate !== undefined ) {
            this.queryParam.standDateTime = formatDate(new Date(this.queryParam.standDate), 'yyyy-MM-dd')
          } else {
            this.queryParam.standDateTime =null
          }
          return reportDayPage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })
        },

        selectedRowKeys: [],
        selectedRows: []
      }
    },

    created() {
      // this.queryParam.reportId='过磅明细表'
      this.loadSupplierSelect()
      this.loadBusinessSelect()
      this.bizCodeList = this.$store.getters.bizCodeList
      // this.bizList = this.$store.getters.bizList
      this.roleId = this.$store.getters.roles
      // 如果是超级管理员，则加载下物料数据
      if (this.roleId === this.config.RoleType.SUPER_ADMIN) {
        this.loadBaseInfoList()
      }

      // 初始化查询条件
      if (!this.queryParam){
        this.queryParam =  {standTime:[moment().startOf('day'), moment().endOf('day')],reportId:'过磅明细表',standDate:moment().startOf('day')}
      }else{
        if (this.queryParam.standTime.length >0){
          this.queryParam.standTime[0] = moment(this.queryParam.standTime[0])
          this.queryParam.standTime[1] = moment(this.queryParam.standTime[1])
        }
      }
    },

    methods: {
      moment,
      disabledDate(current) {
        // Can not select days before today and today
        return current && current > moment().endOf('day')
      },
      getCurrentData(){
        return new Date().toLocaleDateString();
      },
      loadBaseInfoList() {
        // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = baseInfoList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielList = res.materielList
          for (var i = 0; i < this.materielList.length; i++) {
            let materie = this.materielList[i]
            if (!(this.materielData[materie.businessTypeId] instanceof Array)) {
              this.materielData[materie.businessTypeId] = []
            }
            this.materielData[materie.businessTypeId].push(materie)
          }
          this.materList = this.materielData[this.selectedBizId]
        })
      },
      changeReportId(value){
        if(value =='过磅明细表'){
          this.standTimeShow= true
          this.conditionShow= false
        }
        if(value =='称重报表'){
          this.standTimeShow= true
          this.conditionShow= true
        }
        if(value =='水泥出厂日报表'){
          this.standTimeShow= false
          this.conditionShow= true
        }
      },
      queryTable(){
        if (this.queryParam.standTime !== undefined && this.queryParam.standTime.length > 1) {
          this.queryParam['beginStartTime'] = formatDate(new Date(this.queryParam.standTime[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['beginEndTime'] = formatDate(new Date(this.queryParam.standTime[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['beginStartTime'] = null
          this.queryParam['beginEndTime'] = null
        }
        if (this.queryParam.standDate !== undefined ) {
          this.queryParam.standDateTime = formatDate(new Date(this.queryParam.standDate), 'yyyy-MM-dd')
        } else {
          this.queryParam.standDateTime =null
        }
        var value=this.queryParam.reportId
        var nthis = this
        var  field1=this.queryParam.field1
        var  field2=this.queryParam.field2
        var  field3=this.queryParam.field3
        var  field4=this.queryParam.field4
        if(value !='过磅明细表') {
          if (!field1 && !field2 && !field3 && !field4) {
            this.$message.success('条件都为空,请选择！')
            return
          }
        }
        var repeat=false
        if(field1){
          if(field2){
            if(field1 == field2)
              repeat=true
          }
          if(field3){
            if(field1 == field3)
              repeat=true
          }
          if(field4){
            if(field1 == field4)
              repeat=true
          }
        }
        if(field2){
          if(field3){
            if(field2 == field3)
              repeat=true
          }
          if(field4){
            if(field2 == field4)
              repeat=true
          }
        }
        if(field3){
          if(field4){
            if(field3 == field4)
              repeat=true
          }
        }
        if(repeat){
          this.$message.success('条件重复,请重新选择！')
          return
        }
        if(value =="称重报表"){
          this.report2=true
          this.report1=false
          this.report3=false
          this.columns2=[
            {
              title: '总车数',
              dataIndex: 'carNum',
              width: '220px',
            },
            {
              title: '总毛重',
              dataIndex: 'grossTotal',
              width: '220px',
            },
            {
              title: '总皮重',
              dataIndex: 'tareTotal',
              width: '220px',
            },
            {
              title: '总实重',
              dataIndex: 'netTotal',
              width: '220px',
            },
          ]
          this.createColumns(this.columns2,field4);
          this.createColumns(this.columns2,field3);
          this.createColumns(this.columns2,field2);
          this.createColumns(this.columns2,field1);
          setTimeout(
            function(){
              nthis.$refs.table2.refresh();
            },100
          )
        }else if(value =="水泥出厂日报表"){
          if (this.queryParam.standDate == undefined  || this.queryParam.standDate =='' || this.queryParam.standDate ==null ||   this.queryParam.standDate=='NaN-aN-aN') {
            this.$message.success('请选择过日期！')
            Bus.$emit('showSpinning', false)
            return
          }
          this.report3=true
          this.report1=false
          this.report2=false
          this.columns3= [
            {
              title: '包装方式',
              dataIndex: 'materielType',
              width: '220px',
            },
            {
              title: '当日重量',
              dataIndex: 'dayWeight',
              width: '220px',
            },
            {
              title: '当月重量',
              dataIndex: 'monthWeight',
              width: '220px',
            },
            {
              title: '年累计',
              dataIndex: 'yearWeight',
              width: '220px',
            },
            {
              title: '当日车数',
              dataIndex: 'todayCarNum',
              width: '220px',
            },
          ]
          this.createColumns(this.columns3,field4);
          this.createColumns(this.columns3,field3);
          this.createColumns(this.columns3,field2);
          this.createColumns(this.columns3,field1);
          setTimeout(
            function(){
              nthis.$refs.table3.refresh();
            },1000
          )
        }else {
          this.report1=true
          this.report2=false
          this.report3=false
          setTimeout(
            function(){
              nthis.$refs.table1.refresh();
            },100
          )
        }
      },
      createColumns(columns,field){
        if(field){
          if(field =='车号'){
            columns.unshift({
              title: '车号',
              dataIndex: 'vehicleNo',
              width: '220px',
            })
          }
          if(field =='物料名称'){
            columns.unshift({
              title: '物料名称',
              dataIndex: 'materielName',
              width: '220px',
            })
          }
          if(field =='发货单位'){
            columns.unshift({
              title: '发货单位',
              dataIndex: 'unitFrom',
              width: '220px',
            })
          }
          if(field =='收货单位'){
            columns.unshift({
              title: '收货单位',
              dataIndex: 'unitTo',
              width: '220px',
            })
          }
        }
      },
      handleBizChange(value) {
        this.selectedBizId = value
        this.statusList = this.bizCodeList[value]
        if (value === this.config.BusinessTypeId.purchase) {
          this.supplierOrBusList = this.supplierList
        }
        if (value === this.config.BusinessTypeId.sell) {
          this.supplierOrBusList = this.businessList
        }
      },
      loadSupplierSelect() {
        // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = getCorpSupplierList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.supplierList = res
        })
      },

      loadBusinessSelect() {
        new Promise(resolve => {
          const data = corpBusinessList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessList = res
        })
      },

      filterOption(input, option) {
        // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      toggleAdvanced() {
        this.advanced = !this.advanced
      },

      handleStandDetailExport() {
        Bus.$emit('showSpinning', true, "准备导出...")
        if (this.queryParam.standTime !== undefined && this.queryParam.standTime.length > 1) {
          this.queryParam['beginStartTime'] = formatDate(new Date(this.queryParam.standTime[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['beginEndTime'] = formatDate(new Date(this.queryParam.standTime[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['beginStartTime'] = null
          this.queryParam['beginEndTime'] = null
        }
        var value=this.queryParam.reportId
        if(value !='过磅明细表') {
          this.$message.success('请选择报表类型!')
          Bus.$emit('showSpinning', false)
          return
        }
        standDetailExport(this.queryParam)
          .then(res => {
            if (res.code === '0') {
              const token = Vue.ls.get(ACCESS_TOKEN)
              let fileName=res.data
              let url=this.config.downloadStandDetailUrl
              url=url+fileName+'&accessToken='+token;
              window.location.href=url
            }
          }).catch((da) => {
          console.log(da)
        }).finally((res) => {
          Bus.$emit('showSpinning', false)
        })
      },

      standStatisticVoExport() {
        Bus.$emit('showSpinning', true, "准备导出...")
        if (this.queryParam.standTime !== undefined && this.queryParam.standTime.length > 1) {
          this.queryParam['beginStartTime'] = formatDate(new Date(this.queryParam.standTime[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['beginEndTime'] = formatDate(new Date(this.queryParam.standTime[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['beginStartTime'] = null
          this.queryParam['beginEndTime'] = null
        }
        var value=this.queryParam.reportId
        var nthis = this
        var  field1=this.queryParam.field1
        var  field2=this.queryParam.field2
        var  field3=this.queryParam.field3
        var  field4=this.queryParam.field4
        if(value !='称重报表') {
          this.$message.success('请选择报表类型!')
          Bus.$emit('showSpinning', false)
          return
        }else {
          if (!field1 && !field2 && !field3 && !field4) {
            this.$message.success('条件都为空,请选择！')
            Bus.$emit('showSpinning', false)
            return
          }
        }
        standStatisticVoExport(this.queryParam)
          .then(res => {
            if (res.code === '0') {
              const token = Vue.ls.get(ACCESS_TOKEN)
              let fileName=res.data
              let url=this.config.downloadStandStatisticVoUrl
              url=url+fileName+'&accessToken='+token;
              window.location.href=url
            }
          }).catch((da) => {
          console.log(da)
        }).finally((res) => {
          Bus.$emit('showSpinning', false)
        })
      },
      reportVoExport() {
        Bus.$emit('showSpinning', true, "准备导出...")
        if (this.queryParam.standDate !== undefined ) {
          this.queryParam.standDateTime = formatDate(new Date(this.queryParam.standDate), 'yyyy-MM-dd')
        } else {
          this.$message.success('请选择过磅日期！')
          Bus.$emit('showSpinning', false)
          return
        }
        var value=this.queryParam.reportId
        var nthis = this
        var  field1=this.queryParam.field1
        var  field2=this.queryParam.field2
        var  field3=this.queryParam.field3
        var  field4=this.queryParam.field4
        if(value !='水泥出厂日报表') {
          this.$message.success('请选择报表类型!')
          Bus.$emit('showSpinning', false)
          return
        }else {
          if (!field1 && !field2 && !field3 && !field4) {
            this.$message.success('条件都为空,请选择！')
            Bus.$emit('showSpinning', false)
            return
          }
        }
        reportVoExport(this.queryParam)
          .then(res => {
            if (res.code === '0') {
              const token = Vue.ls.get(ACCESS_TOKEN)
              let fileName=res.data
              let url=this.config.downloadReportVoUrl
              url=url+fileName+'&accessToken='+token;
              window.location.href=url
            }
          }).catch((da) => {
          console.log(da)
        }).finally((res) => {
          Bus.$emit('showSpinning', false)
        })
      },
    },
    watch: {}
  }
</script>